<template>
  <div class="chapter-inner-wrap">

    <h4 class="position-relative z-10 theme-intro-number" v-html="'THEME ' + number"></h4>

    <div class="position-relative text-wrap d-flex flex-column">
      <svg class="position-absolute number-vect" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 124 113">
        <linearGradient :id="uuid + 'grad'" gradientTransform="rotate(45 0.5 0.5)">
          <stop offset="0%" :stop-color="grad[0]"/>
          <stop offset="100%" :stop-color="grad[1]"/>
        </linearGradient>

        <text
          class="knockout-50"
          style="font-size: 150px"
          alignment-baseline="hanging"
          :y="isMS || isFF ? 113 : 0"
          x="0"
          :fill="'url(#' + uuid + 'grad)'"
          v-html="number"
        ></text>
      </svg>

      <span class="position-relative d-flex flex-column theme-intro centered-wrap" v-html="data.title"></span>
      <span class="position-relative theme-sub centered-wrap" v-html="data.sub"></span>

      <svg
        class="align-self-center theme01-orb"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 85 82"
        v-if="data.num === 1"
      >
        <defs>
          <linearGradient id="theme01_circle-a" x1="50%" x2="50%" y1="26.741%" y2="78.488%">
            <stop offset="0%" :stop-color="accent"/>
            <stop offset="100%" :stop-color="lighten(accent, 0.7)" stop-opacity="0"/>
          </linearGradient>
        </defs>
        <ellipse cx="42.5" cy="41" fill="url(#theme01_circle-a)" fill-opacity=".7" fill-rule="evenodd" rx="41.5" ry="40"
                 transform="rotate(-30 42.5 41)"/>
      </svg>
    </div>

  </div>
</template>

<script>
  import { leadZeros, gradPtColor, lighten } from '@/lib/funcs'
  import ContentMixin from '@/components/report/mixins/ContentMixin'

  export default {
    name: 'Chapter',
    mixins: [ ContentMixin ],
    computed: {
      number () {
        return leadZeros( this.data.num )
      },
      grad () {
        return this.bg === this.accent
          ? [ gradPtColor( ...this.colorsRev, 0.85 ), gradPtColor( ...this.colorsRev, 0.65 ) ]
          : [ gradPtColor( ...this.colors, 0.6 ), gradPtColor( ...this.colors, 0.15 ) ]
      }
    },
    methods: {
      lighten
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../assets/scss/global/the_goods";

  .theme {
    &-intro-number {
      font-size      : viewport-scale(15);
      margin-bottom  : rem(37);
      margin-top     : rem(10);
      letter-spacing : 0.1333em;
      text-align     : center;
      font-family    : $knockout-30;

      @include screen-md-lg-xl {
        font-size   : rem(20);
        font-weight : 500;
      }
    }

    &-intro {
      font-family : $adobe-clean-serif;
      font-weight : 500;
      font-size   : rem(28);
      line-height : rem(46);
      color       : $white;
      font-style  : italic;

      @include screen-md-lg-xl {
        font-size   : rem(38);
        line-height : rem(56);
      }

      &::after {
        content : "\2014";
        display : block;
      }
    }

    &-sub {
      font-size      : rem(16);
      letter-spacing : rem(2);
      line-height    : rem(35);
      text-transform : uppercase;
      font-family    : $adobe-clean;
      font-weight    : 800;
    }
  }

  .number-vect {
    top       : 0;
    left      : 50%;
    transform : translate(-50%, -25%);
    width     : viewport-scale(124);
    height    : viewport-scale(115);

    @include screen-md-lg-xl {
      width  : rem(125);
      height : rem(118);
    }
  }

  .title {
    font-size   : viewport-scale(32);
    line-height : 1.4375;
  }

  .theme01-orb {
    width  : viewport-scale(83);
    height : viewport-scale(80);
    margin : rem(20) 0 0 0;

    @include screen-md-lg-xl {
      max-height : 128px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/report/content/Chapter.vue